import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form-preview-refresher"
export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.buttonTarget.classList.add("hidden")
  }

  refresh(event) {
    if (event.params.previewSelector) {
      this.showPreviewLoading(event.params.previewSelector)
    }

    document.activeElement?.blur()
    this.element.requestSubmit(this.buttonTarget)
  }

  showPreviewLoading(selector) {
    const preview = this.element.querySelector(selector)
    if (!preview) return

    preview.innerHTML = `
      <div class="flex justify-center py-6">
        <div class="size-6 animate-spin rounded-full border-2 border-gray-300 border-t-indigo-600"></div>
      </div>
    `
  }
}
